// Dr.Rx™ Clinician Account & Preferences
import React, { useState, useEffect } from 'react';
import type { View, Platform } from '../types';
import DataManagementModal from './DataManagementModal';
import DownloadDataModal from './DownloadDataModal';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

const UserIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>;
const StarIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.783-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>;
const ClockIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const DatabaseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" /></svg>;
const DownloadIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>;
const InstallAppIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 11v4m0 0l-2-2m2 2l2-2" /></svg>;
const HelpIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const BugIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>;
const LightbulbIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></svg>;
const InfoIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const BrainIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.24a2 2 0 00-1.806.547a2 2 0 00-.547 1.806l.477 2.387a6 6 0 00.517 3.86l.158.318a6 6 0 00.517 3.86l2.387.477a2 2 0 001.806-.547a2 2 0 00.547-1.806l-.477-2.387a6 6 0 00-.517-3.86l-.158-.318a6 6 0 01-.517-3.86l.477-2.387a2 2 0 01.547-1.806z" /><path strokeLinecap="round" strokeLinejoin="round" d="M14.5 9.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" /></svg>;
const DocumentIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;
const LockIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>;
const ShieldIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 20.944A12.02 12.02 0 0012 22a12.02 12.02 0 009-1.056c.343-.344.65-.72.923-1.132A11.955 11.955 0 0112 2.944z" /></svg>;
const ArrowRightIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>;
const CompassIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const DashboardIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;

const SmallLogoIcon = () => (
    <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="5" fill="#FACC15" />
        <line x1="24" y1="9" x2="24" y2="17" stroke="white" strokeWidth="2" />
        <circle cx="24" cy="7" r="2" fill="white" />
        <line x1="24" y1="31" x2="24" y2="39" stroke="white" strokeWidth="2" />
        <circle cx="24" cy="41" r="2" fill="white" />
        <line x1="9" y1="24" x2="17" y2="24" stroke="white" strokeWidth="2" />
        <circle cx="7" cy="24" r="2" fill="white" />
        <line x1="31" y1="24" x2="39" y2="24" stroke="white" strokeWidth="2" />
        <circle cx="41" cy="24" r="2" fill="white" />
    </svg>
);

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
    <section className="mb-8">
        <h2 className="text-xs font-bold text-gray-400 uppercase tracking-wider px-4 mb-2">{title}</h2>
        <div className="bg-[#15243E] rounded-2xl border border-blue-900/50 divide-y divide-blue-900/50 overflow-hidden shadow-lg">
            {children}
        </div>
    </section>
);

const ListItem: React.FC<{ icon: React.ReactNode; text: string; subtext?: string; children?: React.ReactNode; isLast?: boolean; onClick?: () => void }> = ({ icon, text, subtext, children, onClick }) => (
    <div onClick={onClick} className={`p-4 flex items-center justify-between gap-4 ${onClick ? 'cursor-pointer hover:bg-white/5 transition-colors' : ''}`}>
        <div className="flex items-center gap-4">
            <div className="text-yellow-400">{icon}</div>
            <div>
                <p className="font-semibold text-white">{text}</p>
                {subtext && <p className="text-xs text-gray-400 mt-0.5">{subtext}</p>}
            </div>
        </div>
        <div className="flex items-center gap-2">
            {children}
        </div>
    </div>
);

interface AccountProps {
    onOpenInfoModal: (contentKey: any) => void;
    onNavigate: (view: View) => void;
    autoLogoutDuration?: number;
    onDurationChange?: (minutes: number) => void;
    canInstall?: boolean;
    onInstallClick?: () => void;
    isStandalone?: boolean;
    isPwaInstallable?: boolean;
    isPwaInstalled?: boolean;
    onPwaInstall?: () => void;
    isVoiceEnabled?: boolean;
    onVoiceEnabledChange?: (val: boolean) => void;
    isPushEnabled?: boolean;
    onPushEnabledChange?: (val: boolean) => void;
    isSentryEnabled?: boolean;
    onSentryEnabledChange?: (val: boolean) => void;
    platform: Platform;
    onRestartTour?: () => void;
    onStartTour?: () => void;
}

const Account: React.FC<AccountProps> = ({
    onOpenInfoModal,
    onNavigate,
    autoLogoutDuration = 15,
    onDurationChange,
    canInstall,
    onInstallClick,
    isStandalone,
    isPwaInstallable,
    isPwaInstalled,
    onPwaInstall,
    isVoiceEnabled,
    onVoiceEnabledChange,
    platform,
    onRestartTour,
    onStartTour,
}) => {
    const effectiveCanInstall = canInstall ?? isPwaInstallable ?? false;
    const effectiveIsStandalone = isStandalone ?? isPwaInstalled ?? false;
    const effectiveInstallClick = onInstallClick || onPwaInstall || (() => {});
    const effectiveRestartTour = onRestartTour || onStartTour || (() => {});
    const { user, subscription, logout, isAdmin, reauthenticateAdmin } = useAuth();
    const { showToast } = useToast();
    const [isDataManagementOpen, setIsDataManagementOpen] = useState(false);
    const [isDownloadDataOpen, setIsDownloadDataOpen] = useState(false);

    const appVersion = '2.5.0';

    const getSupportMailto = (subject: string) => {
        const body = `\n\n\n--- System Information (For Support) ---\nApp Version: ${appVersion}\nPlatform: ${platform}\nUser Agent: ${navigator.userAgent}\n-----------------------------------------`;
        return `mailto:support@nvpharmaceutics.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    };

    const getSubscriptionSubtext = () => {
        if (!subscription) return 'Loading...';
        switch (subscription.plan) {
            case 'Free':
                return `${subscription.interactionsLeft} of ${subscription.interactionLimit} daily AI interactions remaining`;
            case 'Plus':
            case 'Pro':
            case 'Teams':
                return 'Unlimited AI Clinical Co-Pilot & All 40+ Calculators';
            default:
                return '';
        }
    };

    const getSubscriptionButtonText = () => {
        if (!subscription) return '';
        return subscription.plan === 'Free' || subscription.plan === 'Trial' ? 'Upgrade' : 'Manage';
    };

    const handleSubscriptionClick = () => {
        if (!subscription) return;
        if (subscription.plan === 'Free' || subscription.plan === 'Trial') {
            onNavigate('pricing');
        } else {
            onNavigate('subscription-management');
        }
    };

    const handleAdminClick = () => {
        reauthenticateAdmin(() => {
            onNavigate('admin-dashboard');
        });
    };

    const handleInstallRowClick = () => {
        if (effectiveIsStandalone) {
            showToast('Dr.Rx™ is already installed and running in standalone mode.', 'success');
        } else {
            effectiveInstallClick();
        }
    };

    return (
        <div className="py-6">
            <header className="mb-8 flex justify-between items-start">
                <div>
                    <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">Account & Settings</h1>
                    <p className="text-gray-400 mt-2 text-sm sm:text-base">
                        Manage your clinician profile, security preferences, and local reference data.
                    </p>
                </div>
                <button
                    onClick={() => onNavigate('dashboard')}
                    className="flex items-center gap-2 opacity-80 hover:opacity-100 transition-all cursor-pointer hover:scale-105"
                >
                    <SmallLogoIcon />
                    <span className="text-sm font-bold text-white hidden sm:inline">
                        Dr.<span className="text-yellow-400">Rx</span>
                        <sup className="text-xs -top-2">TM</sup>
                    </span>
                </button>
            </header>

            <Section title="Clinician Profile & Plan">
                <ListItem icon={<UserIcon />} text={user?.name || 'Clinical Professional'} subtext={user?.email} />
                <ListItem
                    icon={<StarIcon />}
                    text={`Current Plan: ${subscription?.plan || '...'}`}
                    subtext={getSubscriptionSubtext()}
                    onClick={handleSubscriptionClick}
                >
                    <span className="bg-yellow-400 text-gray-950 font-bold py-1.5 px-4 rounded-xl text-sm hover:bg-yellow-300 transition-colors">
                        {getSubscriptionButtonText()}
                    </span>
                </ListItem>
            </Section>

            {isAdmin && (
                <Section title="Admin Operations">
                    <ListItem
                        icon={<DashboardIcon />}
                        text="Admin Ops Command Center"
                        subtext="Live system telemetry, national alert ingestion, editorial queue, and security audit"
                        onClick={handleAdminClick}
                    >
                        <ArrowRightIcon />
                    </ListItem>
                </Section>
            )}

            <Section title="Clinical Workspace Preferences">
                {onVoiceEnabledChange && (
                    <ListItem
                        icon={<BrainIcon />}
                        text="Voice Clinical Dictation"
                        subtext="Enable microphone dictation in the AI Clinical Co-Pilot and Smart Search"
                    >
                        <button
                            onClick={() => {
                                onVoiceEnabledChange(!isVoiceEnabled);
                                showToast(`Voice dictation ${!isVoiceEnabled ? 'enabled' : 'disabled'}.`, 'info', 2000);
                            }}
                            className={`w-12 h-7 rounded-full transition-colors relative ${
                                isVoiceEnabled ? 'bg-emerald-500' : 'bg-gray-600'
                            }`}
                            aria-label="Toggle Voice Dictation"
                        >
                            <div
                                className={`w-5 h-5 bg-white rounded-full absolute top-1 transition-transform ${
                                    isVoiceEnabled ? 'left-6' : 'left-1'
                                }`}
                            />
                        </button>
                    </ListItem>
                )}
                {onDurationChange && (
                    <ListItem
                        icon={<ClockIcon />}
                        text="Inactivity Auto-Lock"
                        subtext="Automatically sign out after idle period at shared clinical workstations"
                    >
                        <select
                            value={autoLogoutDuration}
                            onChange={e => {
                                onDurationChange(Number(e.target.value));
                                showToast('Inactivity auto-lock timer updated.', 'info', 2000);
                            }}
                            className="bg-[#101D35] border border-[#3A4A67] rounded-xl p-2 text-sm text-white focus:outline-none focus:ring-1 focus:ring-yellow-400"
                            aria-label="Inactivity Auto-Lock Duration"
                        >
                            <option value={5}>5 minutes</option>
                            <option value={15}>15 minutes</option>
                            <option value={30}>30 minutes</option>
                            <option value={60}>1 hour</option>
                            <option value={0}>Never</option>
                        </select>
                    </ListItem>
                )}
            </Section>

            <Section title="Data & Application">
                <ListItem
                    icon={<InstallAppIcon />}
                    text={effectiveIsStandalone ? 'App Installed' : 'Install Dr.Rx™ Web App'}
                    subtext={effectiveIsStandalone ? 'Running in standalone PWA mode' : 'Add to home screen or desktop for rapid bedside access'}
                    onClick={handleInstallRowClick}
                >
                    {effectiveIsStandalone ? (
                        <span className="text-xs font-bold text-emerald-400 px-3 py-1 bg-emerald-500/10 rounded-full border border-emerald-500/20">
                            Active
                        </span>
                    ) : (
                        <span className="bg-yellow-400 text-gray-950 font-bold py-1.5 px-4 rounded-xl text-sm hover:bg-yellow-300 transition-colors">
                            {effectiveCanInstall ? 'Install' : 'How to Install'}
                        </span>
                    )}
                </ListItem>
                <ListItem
                    icon={<CompassIcon />}
                    text="Restart Onboarding Tour"
                    subtext="Review key clinical features and navigation shortcuts"
                    onClick={effectiveRestartTour}
                >
                    <ArrowRightIcon />
                </ListItem>
                <ListItem
                    icon={<DatabaseIcon />}
                    text="Manage Local App Data"
                    subtext="Clear cached consultations, study progress, or custom drugs"
                    onClick={() => setIsDataManagementOpen(true)}
                >
                    <ArrowRightIcon />
                </ListItem>
                <ListItem
                    icon={<DownloadIcon />}
                    text="Export My Clinical Data"
                    subtext="Download a JSON archive of your consultations and custom drugs"
                    onClick={() => setIsDownloadDataOpen(true)}
                >
                    <ArrowRightIcon />
                </ListItem>
            </Section>

            <Section title="Support & Feedback">
                <ListItem icon={<HelpIcon />} text="Help & FAQ" onClick={() => onOpenInfoModal('faq')}>
                    <ArrowRightIcon />
                </ListItem>
                <a href={getSupportMailto('Bug Report - Dr.Rx App')} target="_blank" rel="noopener noreferrer" className="block">
                    <ListItem icon={<BugIcon />} text="Report a Clinical or Technical Issue">
                        <ArrowRightIcon />
                    </ListItem>
                </a>
                <a href={getSupportMailto('Feature Request - Dr.Rx App')} target="_blank" rel="noopener noreferrer" className="block">
                    <ListItem icon={<LightbulbIcon />} text="Suggest a Clinical Tool or Feature">
                        <ArrowRightIcon />
                    </ListItem>
                </a>
            </Section>

            <Section title="About & Compliance">
                <ListItem icon={<InfoIcon />} text="About Dr.Rx™" onClick={() => onOpenInfoModal('about')}>
                    <ArrowRightIcon />
                </ListItem>
                <ListItem icon={<BrainIcon />} text="AI Use & Clinical Limitations" onClick={() => onOpenInfoModal('aiLimitations')}>
                    <ArrowRightIcon />
                </ListItem>
                <ListItem icon={<DocumentIcon />} text="Terms of Use" onClick={() => onOpenInfoModal('terms')}>
                    <ArrowRightIcon />
                </ListItem>
                <ListItem icon={<LockIcon />} text="Privacy Policy" onClick={() => onOpenInfoModal('privacy')}>
                    <ArrowRightIcon />
                </ListItem>
                <ListItem icon={<ShieldIcon />} text="HIPAA & De-Identification Statement" onClick={() => onOpenInfoModal('hipaa')}>
                    <ArrowRightIcon />
                </ListItem>
            </Section>

            <div className="text-center mt-10">
                <button
                    onClick={logout}
                    className="bg-red-900/40 text-red-200 border border-red-800/50 font-bold py-2.5 px-8 rounded-xl hover:bg-red-800/60 transition-colors"
                >
                    Sign Out
                </button>
                <p className="text-xs text-gray-500 mt-3 tabular-nums">Dr.Rx™ v{appVersion}</p>
                <p className="text-xs text-gray-600 mt-1">©2025 NV Pharmaceutics LLC. All rights reserved.</p>
            </div>

            {isDataManagementOpen && <DataManagementModal onClose={() => setIsDataManagementOpen(false)} />}
            {isDownloadDataOpen && <DownloadDataModal onClose={() => setIsDownloadDataOpen(false)} />}
        </div>
    );
};

export default Account;
